export default "__VITE_ASSET__LRCxXvIY__"